// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-webcontent-parent {
  overflow-y: auto;
}
.app-webcontent-parent ion-content::part(scroll) {
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-webview/popover-webview/popover-webview.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAAE;EACE,kBAAA;AAEJ","sourcesContent":[".app-webcontent-parent {\n  overflow-y: auto;\n  ion-content::part(scroll) {\n    overflow-y: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
